import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=80bb778e&scoped=true"
import script from "./ChartWrapper.vue?vue&type=script&lang=js"
export * from "./ChartWrapper.vue?vue&type=script&lang=js"
import style0 from "./ChartWrapper.vue?vue&type=style&index=0&id=80bb778e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb778e",
  null
  
)

export default component.exports